<template>
    <div class="confirmation">
        <!--导航栏-->
        <navbar :transparent="isTransparent" activeTo="Home"></navbar>
        <div class="confirmation-wrap">
            <h1 class="font-big">
                {{$t('confirmation_title')}}
            </h1>
            <div class="confirmation-address">
                <div class="confirmation-address-tab">
                    <div class="confirmation-address-tabItem1" v-for="(item,index) in tab" :key="index" @click="chooseOrder($event,index)" >
                        <div class="detail-btn" v-bind:class="{selected:index == num}"></div>
                        <span class="font-mid">{{item.title}}</span>
                    </div>
                </div>
                <div style="clear: both"></div>
                <!--邮寄-->
                <div class="confirmation-address-ship" v-if="this.type == 1 ">
                    <div class="addr_group">
                        <div class="addr_laber font-mid">
                            {{$t('about_ifree_join_sub_name')}}<span>*</span>
                        </div>
                        <div class="addr_item1">
                            <input v-model="shipName" type="text" :placeholder="$t('about_ifree_join_sub_name')">
                        </div>
                    </div>
                    <div class="addr_group">
                        <div class="addr_laber font-mid">
                            {{$t('add_address_area')}}<span>*</span>
                        </div>
                        <div class="addr_item1">
                            <div style="position: relative;display: inline-block">
                                <input  v-model="shipCountry" class="addr_country" type="text" readonly  @click="SelectCountry">
                                <Icon type="arrow-down-b" style="position: absolute;top: 15px;left:70%;"></Icon>
                                <ul class="addr_item1_content" v-show="this.showCountry">
                                    <li v-for="(list,index) in country_list" :key="index" @click="selectTrue(1,list.country_name,list.id)">
                                        <a>{{list.country_name}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="addr_group">
                        <div class="addr_laber font-mid">
                            {{$t('add_address_address')}}<span>*</span>
                        </div>
                        <div class="addr_item2">
                            <textarea v-model="shipAddress"  cols="30" rows="6" :placeholder="$t('add_address_address_full')"></textarea>
                        </div>
                    </div>
                    <div class="addr_group">
                        <div class="addr_laber font-mid">
                            {{$t('add_address_zip_code')}}
                        </div>
                        <div class="addr_item1">
                            <input  v-model="shipZipcode" type="text" :placeholder="$t('add_address_zip_code_full')">
                        </div>
                    </div>
                    <div class="addr_group">
                        <div class="addr_laber font-mid">
                            {{$t('user_center_email')}}<span>*</span>
                        </div>
                        <div class="addr_item1">
                            <input v-model="shipEmail" type="text" :placeholder="$t('user_center_email')">
                        </div>
                    </div>
                    <div class="addr_group">
                        <div class="addr_laber font-mid">
                            {{$t('confirmation_phone')}}<span>*</span>
                        </div>
                        <div class="addr_item1">
                            <input v-model="shipPhone"  type="text" :placeholder="$t('about_ifree_join_sub_number')">
                        </div>
                    </div>
                    <div class="addr_tip">
                        <p class="font-small">{{$t('confirmation_tip')}}</p>
                    </div>
                    <div class="addr_btn">
                        <button @click="checkAddr">{{$t('confirmation_save')}}</button>
                    </div>
                </div>
                <!--门店自取-->
                <div class="confirmation-address-ship" v-else>
                    <div class="addr_group">
                        <div class="addr_laber font-mid">
                            {{$t('about_ifree_join_sub_name')}}<span>*</span>
                        </div>
                        <div class="addr_item1">
                            <input v-model="takeName" type="text" :placeholder="$t('about_ifree_join_sub_name')">
                        </div>
                    </div>
                    <div class="addr_group">
                        <div class="addr_laber font-mid">
                            {{$t('add_address_area')}}<span>*</span>
                        </div>
                        <div class="addr_item1">
                            <div style="position: relative;display: inline-block">
                                <input  v-model="takeCountry" class="addr_country" type="text" readonly  @click="SelectCountry">
                                <Icon type="arrow-down-b" style="position: absolute;top: 15px;left:70%;"></Icon>
                                <ul class="addr_item1_content" v-show="this.showCountry">
                                    <li v-for="(list,index) in country_list" :key="index" @click="selectTrue(2,list.country_name,list.id)">
                                        <a>{{list.country_name}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="addr_group">
                        <div class="addr_laber font-mid">
                            {{$t('user_center_email')}}<span>*</span>
                        </div>
                        <div class="addr_item1">
                            <input  v-model="takeEmail" type="text" :placeholder="$t('user_center_email')">
                        </div>
                    </div>
                    <div class="addr_group">
                        <div class="addr_laber font-mid">
                            {{$t('confirmation_phone')}}<span>*</span>
                        </div>
                        <div class="addr_item1">
                            <input v-model="takePhone" type="text" :placeholder="$t('about_ifree_join_sub_number')">
                        </div>
                    </div>
                    <div class="addr_tip">
                        <p class="font-small">{{$t('confirmation_tip')}}</p>
                    </div>
                    <div class="store">
                        <p class="font-mid">{{$t('confirmation_close')}}</p>
                        <Row>
                            <i-col :lg="12" :md="12" :sm="24" :xs="24" v-for="(list,index) in store_list" :key="index" >
                                <div class="store_item" v-bind:class="{ative:index == storeNum}" @click="changeStore(index,list.id)">
                                    <p class="font-mid">{{list.name}}</p>
                                    <div class="font-mid store_content" v-if="ShowThis == index">{{list.address}}</div>
                                </div>
                                <div class="store_more">
                                    <a class="font-small" @click="ShowThisContent(index)">{{$t('add_address_address')}} <Icon type="chevron-right"></Icon></a>
                                </div>
                            </i-col>
                        </Row>
                    </div>
                    <div class="addr_btn">
                        <button @click="checkAddr">{{$t('confirmation_save')}}</button>
                    </div>
                </div>
            </div>
            <div class="confirmation-payment" style="display: none">
                <steps :current="0">
                    <step :title="$t('order_details_state_1')"></step>
                    <step :title="$t('order_details_state_2')"></step>
                    <step :title="$t('order_details_state_3')"></step>
                </steps>
            </div>
        </div>
    </div>
</template>

<script>
    import navbar from '../Common/Navbar.vue'
    import Signature from '../../lib/Signature'

    export default {
        data () {
            return {
                shipName:'',
                shipCountry:this.$t('confirmation_china'),
                shipCountryid:35,
                shipAddress:'',
                shipZipcode:'',
                shipEmail:'',
                shipPhone:'',
                takeName:'',
                takeEmail:'',
                takePhone:'',
                takeId:35,
                takeStoreId:1,
                takeCountry:this.$t('confirmation_china'),
                isTransparent: false,
                showCountry:false,
                country_list:[],
                num:0,
                storeNum:0,
                ShowThis:111,
                type:1,
                tab:[
                    {
                        title:this.$t('confirmation_shipping')

                    },
                    {
                        title:this.$t('confirmation_pickup')
                    }
                ],
                store_list: []
            }
        },
        components: {
            navbar
        },
        methods : {
            //模拟select
            selectTrue (type,name,id) {
                if(type == 1) {
                    this.shipCountry = name
                    this.shipCountryid = id
                }else{
                    this.takeCountry = name
                    this.takeId = id
                }
                this.showCountry = false

            },
            SelectCountry () {
                 this.showCountry = true
            },
            //tab
            chooseOrder:function (e,index){
                this.num = index
                if(index == 0) {
                    this.type = 1
                }else{
                    this.type = 2
                }
            },
            //选择门店
            changeStore:function (index,id) {
                this.storeNum = index
                this.ShowThis = 111
                this.takeStoreId = id
            },
            //详情
            ShowThisContent (index) {
                this.ShowThis = index
            },
            //保存地址
            checkAddr () {
                const module = 'index.php/tourists/address'
                let data = {}
                data.account = this.forget_psw_email
                data.sub_time = Signature.timestamp()
                data.lang = this.$i18n.locale
                data.sign = Signature.create(module, data.sub_time)
                data.tourists_token = this.Local.get('tourists_token')
                if(this.type == 1) {
                    data.type = 1
                    data.name = this.shipName
                    data.country = this.shipCountryid
                    data.address = this.shipAddress
                    data.mobile = this.shipPhone
                    data.email = this.shipEmail
                    data.zipcode = this.shipZipcode
                    data.type = 1
                }else{
                    data.name = this.takeName
                    data.country = this.takeId
                    data.email = this.takeEmail
                    data.mobile = this.takePhone
                    data.store_id = this.takeStoreId
                    data.type = 2
                }
                this.$http.post(process.env.BASEURL + module, data).then(function (resp) {
                    if (parseInt(resp.data.code) === 2001) {
                        this.$Message.error(resp.data.msg)
                        return false
                    }
                    if (parseInt(resp.data.code) === 2000) {
                        this.$router.push({
                            name: 'Settlement',
                            query: {
                                goods_id: this.Local.get('CartGoods_id'),
                                number: this.Local.get('CartGoods_number')
                            }
                        })
                    }else{
                        this.$Message.error(resp.data.msg)
                        return false
                    }
                }.bind(this))
            },
            //获取邮寄国家
            getCountry () {
                let module = 'index.php/index/user/getcountry'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.lang = this.$i18n.locale
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                }).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.country_list = resp.data.data.country_list
                    }
                }.bind(this))
            },
            //获取自取门店
            getStore () {
                let module = 'index.php/offline_store'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.lang = this.$i18n.locale
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                }).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.store_list = resp.data.data
                    }
                }.bind(this))
            }
        },
        created () {
            //默认显示
            if (this.num == 0) {
                this.type = 1
            }else{
                this.type = 2
            }

            //获取邮寄国家
            this.getCountry ()

            //获取自取门店
            this.getStore ()
        }

    }
</script>

<style lang="scss" scpoed>
    @import "../../scss/_confirmation.scss";
</style>



// WEBPACK FOOTER //
// Confirmation.vue?2a6e5d87